module.exports = __webpack_public_path__ + "media/images/p-about/partner/dummy-623804e3c029ca60378708619e1161e9.png";